module.exports = __webpack_public_path__ + "img/aneuguide.604fde19.png";